import React, { useState, useEffect } from 'react';
import { GetObjectsFiles, DownloadFile, Logout, Toastmessage, Translate, OpenFile } from '../Functions';
import { ToastContainer } from 'react-toastify';
import { Input, CheckBox, Button} from '../Controls/Controls';

function ObjectView() 
{
    const [data, setData] = useState([]);
    const [openObjects, setOpenObjects] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try 
        {
            const objects = await GetObjectsFiles();
            setData(JSON.parse(objects) || []);
        } 
        catch (error) 
        {
            console.log(error);
        }
    };

    const toggleObject = (index) => {
        if (openObjects.includes(index)) 
        {
            setOpenObjects(openObjects.filter(item => item !== index));
        } 
        else 
        {
            setOpenObjects([...openObjects, index]);
        }
    };

    const handleFolderClick = async (folderName, index, ID = "") => {
        try {
            const objects = await GetObjectsFiles(folderName, ID);
            const parsedData = JSON.parse(objects);

            if (!Array.isArray(parsedData) || parsedData.length === 0) 
            {
                Toastmessage("Es wurden keine Unterordner oder Dateien gefunden.", 3);
            }
            else
            {
                const responseData = parsedData[0];
                setData(prevData => {
                    const newData = [...prevData];
                    newData[index] = responseData;
                    return newData;
                });
                if (!openObjects.includes(index)) {
                    setOpenObjects([...openObjects, index]);
                }
            }
        }
        catch (error) 
        {
            console.log(error);
        }
    };

    const handleFileClick = (file) => {
        DownloadFile(file);
    };

/*     const handleFileOpenClick = (file) => {
        OpenFile(file);
    }; */

    return (
        <div>
            <ToastContainer />
            <div className="container mt-5">
                <div className="d-flex justify-content-end logout" onClick={() => { Logout() }}>
                    {Translate("Logout")}
                </div>
                <div className="row">
                    <div className="col-md-6 d-flex align-items-start">
                        <img src="https://static.wixstatic.com/media/e2f2a9_e58de2ec1ac84060afdf68c4b4ea1726~mv2.png/v1/fill/w_332,h_111,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/IFMS_LOGO.png" className="nav-logo" alt="logo" />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col-md-12 d-flex align-items-center justify-content-center">
                        <h1 className="subject">IFMS - Kundenportal</h1>
                    </div>
                </div>
                <br />
    
                <div id="cardContainer">
                    {data.map((objekt, objektIndex) => (
                        <div key={objektIndex} className="card mb-4">
                            <div className="card-header d-flex justify-content-between align-items-center cardHeader" onClick={() => toggleObject(objektIndex)} style={{ cursor: 'pointer' }}>
                                <h3 className="mb-0 cardTitle text-truncate">{objekt.Objekt}</h3>
                                <div className="triangle" style={{ transform: openObjects.includes(objektIndex) ? 'rotate(180deg)' : 'rotate(0deg)' }}></div>
                            </div>
                        
                            {openObjects.includes(objektIndex) && (
                                <div className="card-body cardBody">
                                  <div className="text-center mb-3 fw-bold fs-5">
                                        {objekt.Nav.split('|').map((item, index, array) => (
                                            <span key={index} className="navPaths">
                                                {index > 0 && item && " / "}
                                                {index === 0 && " ./ "}
                                                <span onClick={() => {
                                                    const newPath = objekt.MainPath + "\\" + objekt.Nav.split("|").slice(1, index + 1).filter(x => x).join("\\");
                                                    handleFolderClick(newPath, objektIndex, objekt.ID);
                                                }}>
                                                    {item}
                                                </span>
                                            </span>
                                        ))}
                                    </div>

                                    {objekt.Ordner && objekt.Ordner.map((folder, folderIndex) => (
                                        <div className="mb-1">
                                            <ul className="list-group">
                                                <li key={folderIndex} className="list-group-item d-flex justify-content-between align-items-center">
                                                    {folder.Type === "folder" ? (
                                                        <h5 className="folderSubject" onClick={() => handleFolderClick(objekt.CurrPath + "\\" + folder.Name, objektIndex, objekt.ID)}>{folder.Name}</h5>
                                                    ) : (
                                                        <div className="text-truncate fileOpen" onClick={() => OpenFile(folder)}>
                                                            <span>{folder.Datum} - </span>
                                                            <span>{folder.Name}</span>
                                                        </div>
                                                    )}

                                                    {folder.Type === "file" && folder.Dateien && folder.Dateien.map((file, fileIndex) => (
                                                        <div key={fileIndex} className="mb-3">
                                                            <div className="text-truncate">
                                                                <span>{file.Datum} - </span>
                                                                <span>{file.Name}</span>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    
                                                    {folder.Type === "file" ? (
                                                        <div>
                                                            <Button btnClassName={"btn btn-primary"} btnStyle={{ width: "170px", fontSize: "14px" }}  btnText={ "Download" } inputOptionalParams={{ onClick: () => handleFileClick(folder) }} />
                                                        </div>
                                                    ) : (
                                                        <div></div>
                                                    )}
                                                </li>
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );    
}

export default ObjectView;
